import { ApiResponse, AxiosErrorCustom, axiosInstance } from '@/lib/axios';
import { TypedMutationConfig } from '@/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import { z } from 'zod';
import { TLabelCase } from '../types/label-case.type';

export const DeleteLabelCaseValidationSchema = z.object({
  labelCaseId: z.string().min(1),
});
export type TDeleteLabelCaseValidation = z.infer<typeof DeleteLabelCaseValidationSchema>;
export type TDeleteLabelCasePayload = TDeleteLabelCaseValidation;
export type TDeleteLabelCaseResponse = ApiResponse<TLabelCase>;

export const deleteLabelCase = (payload: TDeleteLabelCasePayload): Promise<TDeleteLabelCaseResponse> => {
  const url = `/label-case/${payload.labelCaseId}`;

  return axiosInstance.delete(url);
};

type TUseDeleteLabelCaseMutationOptions = {
  mutationConfigOptions?: TypedMutationConfig<typeof deleteLabelCase, AxiosErrorCustom>;
};

export const useDeleteLabelCaseMutation = ({ mutationConfigOptions }: TUseDeleteLabelCaseMutationOptions) => {
  const { ...restConfigOptions } = mutationConfigOptions ?? {};

  return useMutation({
    mutationFn: deleteLabelCase,
    ...restConfigOptions,
  });
};
